const getLinkColors = (val, isDashboard = false, isResult = false) => {
  if (isResult) return '#fff';
  if (val === 'survive') return '#5D5CE2';
  return '#0BD855';
};

export default getLinkColors;
